import React, {useState} from 'react';
import styled from '@mui/system/styled';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import {useDispatch} from 'react-redux';
import {logout} from '../actions/userActions';
import {useNavigate} from 'react-router-dom';

const drawerWidth = 240;

const Header = ({handleDrawerToggle}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goToProfile = () => {
    handleClose();
    navigate('/profile');
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <CustomAppBar color="primary" position="fixed">
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{mr: 2, display: {sm: 'none'}}}>
          <MenuIcon />
        </IconButton>

        <ClickAwayListener onClickAway={handleClose}>
          <Box ml="auto">
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit">
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              sx={{mt: '40px'}}
              open={Boolean(anchorEl)}
              onClose={handleClose}>
              <MenuItem onClick={goToProfile}>Profile</MenuItem>
              <MenuItem onClick={handleLogout}>Log out</MenuItem>
            </Menu>
          </Box>
        </ClickAwayListener>
      </Toolbar>
    </CustomAppBar>
  );
};

const CustomAppBar = styled(AppBar)`
  width: {
    sm: calc(100% - ${drawerWidth}px);
  }
  ml: {
    sm: ${drawerWidth}px;
  }
`;

export default Header;
